import { IOnSaveDateProps } from '@/interfaces';
import { convertDateToTheFormatMMDDYYYY } from '@/utils/convertDateToTheFormatMMDDYYYY';
import { handleOnChange } from './handleOnChange';

export function onSaveDate({
  date,
  onChange,
  hookFormOnChange,
  maxDate,
  dateFormatByCultureCode,
}: IOnSaveDateProps) {
  if (date?.length < 10 || !date) return;

  const datePatternMatched = /\d{1,2}\/|-\d{2}\/|-\d{4}/.test(date);
  const convertedDate = datePatternMatched
    ? new Date(convertDateToTheFormatMMDDYYYY(date, dateFormatByCultureCode))
    : '';
  const finalDate = maxDate && convertedDate > maxDate ? '' : convertedDate;

  handleOnChange({
    date: datePatternMatched ? finalDate : '',
    onChange,
    hookFormOnChange,
  });
}
